// themeConfig.js
import { theme } from "antd";
import { colors } from "./antdTheme";

export const lightTheme = {
    algorithm: theme.defaultAlgorithm,
    token: {
        colorText: colors?.inkBlack,
    },
    components: {
        Layout: {
            headerBg: colors?.lightGrey,
            headerColor: colors?.lightGrey,
            siderBg: colors?.lightGrey,
        },
        Menu: {
            itemBg: colors?.lightGrey,
            itemColor: colors?.oxfordBlue,
        },
        Card: {
            colorBgContainer: "#ffffff",
        },
        Table: {
            headerBg: "#f0f2f5",
            rowHoverBg: "#e6f7ff"
        }
    }
};

export const darkTheme = {
    algorithm: theme.darkAlgorithm,
    token: {
        colorBgBase: "#0F1117",
        colorBgContainer: "#161A23",
        colorTextBase: "#e6e6e6",
        colorPrimary: "#38BDF8",
    },
    components: {
        Layout: {
            headerBg: colors?.oxfordBlue,
            headerColor: colors?.oxfordBlue,
            siderBg: colors?.oxfordBlue,
        },
        Menu: {
            itemBg: colors?.oxfordBlue,
            itemColor: colors?.ivory,
        },
        Card: {
            colorBgContainer: "#161A23",
        },
        Table: {
            headerBg: "#1F2430",
            rowHoverBg: "#232832"
        }
    }
};
